import { render, staticRenderFns } from "./CARequestAttachPop.vue?vue&type=template&id=5b970149"
import script from "./CARequestAttachPop.vue?vue&type=script&lang=js"
export * from "./CARequestAttachPop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b970149')) {
      api.createRecord('5b970149', component.options)
    } else {
      api.reload('5b970149', component.options)
    }
    module.hot.accept("./CARequestAttachPop.vue?vue&type=template&id=5b970149", function () {
      api.rerender('5b970149', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/trans/popup/CARequestAttachPop.vue"
export default component.exports